import React, { useEffect, useState } from "react";
import { padalaServices } from "../services/PadalaServices";
import { adminServices } from "../services/AdminServices";
import DataTable, { Alignment } from "react-data-table-component";
import { ReactComponent as TransactionIcon } from "../icons/receipt.svg";
import LoadingModal from "../components/LoadingModal";
import Button from '../components/Button';
import SearchBar from "../components/SearchBar";
import { formatCurrency } from "../tools/tool";
import InputText1 from "../components/InputText1";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import withAuthorization from "../components/withAuthorization";
import { logExport } from "../services/ExportLogService";
const parseCurrencyToNumber = value => {
  if (value === null || value === undefined) return 0;
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  const raw = String(value).trim();
  if (!raw) return 0;
  const isParenNegative = raw.startsWith("(") && raw.endsWith(")");
  const normalized = (isParenNegative ? raw.slice(1, -1) : raw).replace(/[^0-9.-]/g, "");
  const parsed = Number(normalized);
  if (!Number.isFinite(parsed)) return 0;
  return isParenNegative ? -Math.abs(parsed) : parsed;
};
const parsePercentToNumber = value => {
  if (value === null || value === undefined) return 0;
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  const raw = String(value).trim();
  if (!raw) return 0;
  const normalized = raw.replace(/%/g, "");
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};
const KioskReports = () => {
  const [kioskSales, setKioskSales] = useState(null);
  const [data, setData] = useState([]);
  // const [columns, setColumns] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  let columns = [{
    name: 'ID',
    selector: row => row.sequence,
    sortable: true,
    width: "70px"
  }, {
    name: 'Transaction Date',
    selector: row => new Date(row.reg_date).toLocaleString(),
    sortable: true
  }, {
    name: 'Voucher Number',
    selector: row => row.voucher_number,
    sortable: true
  }, {
    name: 'PDL Name',
    selector: row => row.pdl_name,
    sortable: true,
    wrap: true
  }, {
    name: 'Service',
    selector: row => row.service,
    sortable: true,
    width: "100px",
    wrap: true
  }, {
    name: 'QTY',
    selector: row => row.qty,
    sortable: true,
    width: "80px"
  }, {
    name: 'Unit Price',
    selector: row => parseCurrencyToNumber(row.unitPrice),
    cell: row => formatCurrency(parseCurrencyToNumber(row.unitPrice)),
    sortable: true,
    width: "80px"
  }, {
    name: 'Gross Amount',
    selector: row => parseCurrencyToNumber(row.price),
    cell: row => formatCurrency(parseCurrencyToNumber(row.price)),
    sortable: true,
    right: true,
    headerStyle: {
      textAlign: 'center'
    }
  }, {
    name: 'Service Fee',
    selector: row => parseCurrencyToNumber(row.service_fee),
    cell: row => formatCurrency(parseCurrencyToNumber(row.service_fee)),
    sortable: true,
    right: true,
    headerStyle: {
      textAlign: 'center'
    }
  }, {
    name: 'Percent',
    selector: row => parsePercentToNumber(row.percent),
    cell: row => `${parsePercentToNumber(row.percent)}%`,
    sortable: true,
    right: true,
    headerStyle: {
      textAlign: 'center'
    }
  }, {
    name: 'Net Amount',
    selector: row => parseCurrencyToNumber(row.total_price),
    cell: row => formatCurrency(parseCurrencyToNumber(row.total_price)),
    sortable: true,
    right: true,
    headerStyle: {
      textAlign: 'center'
    }
  }, {
    name: 'Merchant Name',
    selector: row => row.merchant_name,
    sortable: true,
    wrap: true
  }];
  useEffect(() => {
    setLoading(true);
    KioskSales();
  }, []);
  const exportToCSV = async data => {
    if (!data || data.length === 0) return;

    // Log the export
    await logExport('Kiosk Sales Report');
    const headers = ['ID', 'Transaction Date', 'Voucher Number', 'PDL Name', 'Service', 'Unit Price', 'QTY', 'Gross Amount', 'Service Fee', 'Percent', 'Net Amount', 'Merchant Name'];
    const rows = data.map(row => [row.sequence, new Date(row.reg_date).toLocaleString(), row.voucher_number, row.pdl_name, row.service, row.unitPrice,
    // raw value
    row.qty, row.price,
    // raw value
    row.service_fee,
    // raw value
    `${row.percent}%`, row.total_price,
    // raw value
    row.merchant_name]);
    const csvContent = [headers, ...rows].map(row => row.map(field => `"${field}"`).join(',')).join('\n');
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'KioskSalesReport.csv');
    link.click();
  };
  const KioskSales = () => {
    adminServices.storeProcedure2('kiosk_sales_report', {}).then(r => {
      setKioskSales(null);
      setKioskSales(r.data);
      setData(r.data);
      setFilteredData(r.data);
      let gT = r.data.reduce((total, item) => total + item.total_price, 0);
      setGrandTotal(gT);
      setLoading(false);
    }).catch(error => {
      if (error.status === 401) {
        window.location.href = "/";
      }
    });
  };
  const KioskRange = () => {
    adminServices.storeProcedure2('kiosk_sales_report_range', {
      dateFrom: dateFrom,
      dateTo: dateTo
    }).then(r => {
      setKioskSales(null);
      setKioskSales(r.data);
      setData(r.data);
      setFilteredData(r.data);
      let gT = r.data.reduce((total, item) => total + item.total_price, 0);
      setGrandTotal(gT);
      setLoading(false);
    }).catch(error => {
      if (error.status === 401) {
        window.location.href = "/";
      }
    });
  };
  return <div>
      <LoadingModal show={loading} message={"Loading Kiosk Sales Report..."} />
      <div style={{
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: 10,
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center'
    }}>
          <TransactionIcon style={{
        width: "50px",
        height: "50px",
        marginRight: "10px",
        background: 'transparent'
      }} />
         Kiosk Sales Report ({formatCurrency(grandTotal)})
      </div>

      <div className="flexRow" style={{
      width: '50%'
    }}>
          <InputText1 title={"Date From"} type="date" value={dateFrom} onChange={e => {
        setDateFrom(e.target.value);
      }} />

         <InputText1 title={"Date To"} type="date" value={dateTo} onChange={async e => {
        setDateTo(e.target.value);
      }} />

          <div style={{
        marginTop: 18
      }}>
            <Button variant={"primary"} onClick={KioskRange}>Search</Button>
          </div>

      </div>

      <div className="flexRow">
        <div className="flexRow filterDiv">
          <SearchBar placeholder="Search Kiosks Sales Report" onChange={e => {
          const value = e.target.value.toLowerCase();
          const filtered = data.filter(item => Object.keys(item).some(key => item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase())));
          setFilteredData(filtered);
          let gT = filtered.reduce((total, item) => total + item.total_price, 0);
          setGrandTotal(gT);
        }} />
        </div>
        &nbsp;&nbsp;
        <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end"
      }}>
        </div>
        <div className="spacer"></div>
        <Button variant={"success"} size={'xs'} onClick={() => exportToCSV(filteredData)}> Export to CSV </Button>
      </div>
        <br />
        <DataTable columns={columns} data={filteredData} pagination={false} persistTableHead persistTableBody striped highlightOnHover style={{
      zIndex: 0
    }} />
      
    </div>;
};
export default withAuthorization(KioskReports, 5);